<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <UserDataAddressForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserDataAddressForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    UserDataAddressForm,
    Loader
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  props: {
    userDataAddressId: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'userdataaddress/update/isLoading',
      error: 'userdataaddress/update/error',
      deleteError: 'userdataaddress/del/error',
      deleteLoading: 'userdataaddress/del/isLoading',
      created: 'userdataaddress/create/created',
      deleted: 'userdataaddress/del/deleted',
      retrieved: 'userdataaddress/update/retrieved',
      updated: 'userdataaddress/update/updated',
      violations: 'userdataaddress/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }
      this.$router.push({ name: 'UserDataAddressList' })
    },
    updated: function (updated) {
      this.$store.state.modals.userdataaddress.update.updated = 1
      this.$store.state.modals.userdataaddress.update.close = 1
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    if (this.userDataAddressId) {
      this.retrieve(decodeURIComponent(this.userDataAddressId))
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'userdataaddress/create/reset',
      deleteItem: 'userdataaddress/del/del',
      delReset: 'userdataaddress/del/reset',
      retrieve: 'userdataaddress/update/retrieve',
      updateReset: 'userdataaddress/update/reset',
      update: 'userdataaddress/update/update',
      updateRetrieved: 'userdataaddress/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this userdataaddress ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
